enum ACTIONS {
    FETCH_FIELDS = 'FETCH_FIELDS'
}

export default ACTIONS;